module.exports = __webpack_public_path__ + "img/DSC_2772-xl.3caef7fd.png";